import { CloseOutlineIcon } from '@carboncopyco/icons';
import classNames from 'classnames';
import type React from 'react';
import { Spacer } from '../Spacer';

export interface TagProps {
  onClose?: () => void;
  children: React.ReactNode | React.ReactNode[];
  small?: boolean;
  danger?: boolean;
}

export const Tag = ({ children, onClose, small, danger }: TagProps) => {
  return (
    <div
      className={classNames(
        {
          'py-ds-3': small,
          'py-1': !small,
          'border-ds-danger-400 border': danger,
        },
        'bg-ds-natural-50 items-center justify-between flex px-1.5 rounded hover:bg-ds-natural-100 w-fit'
      )}
    >
      <div className="justify-center items-center flex">{children}</div>
      <Spacer amount={0.375} />
      {onClose && (
        <div
          className="flex cursor-pointer"
          onClick={onClose}
        >
          <CloseOutlineIcon size={16} />
        </div>
      )}
    </div>
  );
};
